/* eslint-disable no-undef */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import store from "./store";
import { ApiHandlerComponent } from "vuex-api";
// import VueMarkdown from "vue-markdown";
import CenterContainer from "@/components/ui/center-container";
import Loading from "@/components/ui/loading";
import vueBulmaComponents from "vue-bulma-components";
import VShowdown from "./components/ui/v-showdown";
// Vue.use(require("vue-moment"));
import GlobalContainer from "./components/ui/global-content-container";
import Raven from "raven-js";
import RavenVue from "raven-js/plugins/vue";
import axios from "axios";
import VueAnalytics from "vue-analytics";
import vClickOutside from "v-click-outside";
import { hoc } from "vuex-api";

if (navigator && navigator.serviceWorker) {
  navigator.serviceWorker.getRegistrations().then(function(registrations) {
    for (let registration of registrations) {
      registration.unregister();
    }
  });
}

Vue.use(VueAnalytics, {
  id: ["UA-119928821-1", "UA-90550101-4"],
  router
});

axios.interceptors.response.use(
  function(response) {
    // Do something with response data
    return response;
  },
  function(error) {
    if (error.response.status === 401) {
      localStorage.removeItem("token");
    }
    return Promise.reject(error);
  }
);

if (process && process.env.SENTRY_DSN) {
  Raven.config(process.env.SENTRY_DSN)
    .addPlugin(RavenVue, Vue)
    .install();
}

Vue.use(vClickOutside);

Vue.use(vueBulmaComponents);
Vue.config.productionTip = false;
Vue.component(
  "contenful-apis",
  ApiHandlerComponent({
    requestConfig: {
      baseURL: "https://cdn.contentful.com",
      headers: {
        Authorization:
          "Bearer a668f1bb4d9f2c93e9f6f4dfa8954ea8a1ae452c1a1cfb354293df81f08895e9"
      }
    }
  })
);
Vue.component("vuex-api-hoc", hoc);
Vue.component(
  "bff-api",
  ApiHandlerComponent({
    requestConfig: {
      baseURL: "https://metis-bff.herokuapp.com/api",
      headers: localStorage.getItem("user-token") && {
        Authorization: `Bearer ${localStorage.getItem("user-token")}`
      }
    }
  })
);
Vue.component("global-container", GlobalContainer);
Vue.component("VShowdown", VShowdown);
Vue.component("vue-markdown", {});
Vue.component("center-container", CenterContainer);
Vue.component("loading", Loading);
/* eslint-disable no-new */
new Vue({
  store,
  router,
  template: "<App/>",
  components: { App }
}).$mount("#app");
